/**
 * Marks which color value is selected.
 * A swatch id match wins when the open product id is one of the variation groups.
 * Otherwise the color code is used, so a variant id (cart edit) still highlights
 * the shopper's own color.
 *
 * @param {Array} values - Color variation values.
 * @param {string} pid - Product id Quick View was opened with.
 * @param {string} colorParam - Selected color code.
 * @returns {Array}
 */
export const markSelectedColorValue = (values, pid, colorParam) => {
    const list = values || []
    const selectBySwatchId = list.some((value) => value?.swatchId && value.swatchId === pid)

    return list.map((value) => ({
        ...value,
        isSelected: selectBySwatchId ? value?.swatchId === pid : value?.value === colorParam
    }))
}
